import * as t from "io-ts";

export const SectionDescriptionV = t.type({
  type: t.string,
  sectionFriendlyName: t.string,
  description: t.string
});

export const PageDescriptionV = t.type({
  title: t.string,
  sections: t.array(SectionDescriptionV),
  includeInMainMenu: t.boolean,
});

export type SectionDescription = t.TypeOf<typeof SectionDescriptionV>;

export type PageDescription = t.TypeOf<typeof PageDescriptionV>;

export const SitemapV = t.array(PageDescriptionV);

export type Sitemap = t.TypeOf<typeof SitemapV>;

export const PageAISettingsV = t.partial({
  pageDescription: PageDescriptionV,
  shouldGenerateOnInitialLoad: t.boolean
});

export type PageAISettings = t.TypeOf<typeof PageAISettingsV>;

export const ListOfSectionsForPageV = t.type({
  sections: t.array(SectionDescriptionV)
});

export type ListOfSectionsForPage = t.TypeOf<typeof ListOfSectionsForPageV>;

export const AIServerV = t.type({
  url: t.string, // no trailing slash
  key: t.string
});

export type AIServer = t.TypeOf<typeof AIServerV>;